import React, { useEffect, useState } from "react";
import { api, resolveImg } from "@/lib/api";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import About from "@/components/site/About";
import InternationalExperience from "@/components/site/InternationalExperience";
import FeaturedBooks from "@/components/site/FeaturedBooks";
import WhoFor from "@/components/site/WhoFor";
import WhyRead from "@/components/site/WhyRead";
import Testimonials from "@/components/site/Testimonials";
import TrustSection from "@/components/site/TrustSection";
import ComingSoon from "@/components/site/ComingSoon";
import Newsletter from "@/components/site/Newsletter";
import Social from "@/components/site/Social";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function injectStructuredData(books) {
  const existing = document.getElementById("ld-books");
  if (existing) existing.remove();
  const graph = [
    {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Kate Mercer",
      jobTitle: "Author",
      url: "https://katemercerbooks.com",
      sameAs: ["https://instagram.com/katemercerbooks", "https://tiktok.com/@katemercerbooks"],
      knowsAbout: ["Education", "Study Skills", "Career Development", "Artificial Intelligence", "Learning"],
    },
    ...books
      .filter((b) => !b.coming_soon)
      .map((b) => ({
        "@context": "https://schema.org",
        "@type": "Book",
        name: b.title,
        author: { "@type": "Person", name: "Kate Mercer" },
        description: b.description,
        image: resolveImg(b.cover_image),
        ...(b.goodreads_rating
          ? {
              aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: b.goodreads_rating,
                ratingCount: b.goodreads_ratings_count || 1,
                bestRating: 5,
              },
            }
          : {}),
        ...(b.goodreads_link ? { sameAs: b.goodreads_link } : {}),
        offers: b.amazon_link
          ? { "@type": "Offer", url: b.amazon_link, availability: "https://schema.org/InStock", seller: { "@type": "Organization", name: "Amazon" } }
          : undefined,
      })),
  ];
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = "ld-books";
  script.text = JSON.stringify(graph);
  document.head.appendChild(script);
}

export default function Home() {
  const [config, setConfig] = useState({});
  const [books, setBooks] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    document.title = "Kate Mercer — Books on Study Skills, Careers & AI";
    Promise.all([
      api.get("/config").then((r) => setConfig(r.data || {})),
      api.get("/books").then((r) => setBooks((r.data || []).slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0)))),
      api.get("/testimonials").then((r) => setTestimonials(r.data || [])),
    ]).catch(() => {});
  }, []);

  useEffect(() => {
    if (books.length) injectStructuredData(books);
  }, [books]);

  return (
    <div className="App bg-white">
      <Navbar />
      <main>
        <Hero config={config} books={books} />
        <TrustBar config={config} />
        <About config={config} />
        <InternationalExperience />
        <FeaturedBooks books={books} />
        <Newsletter />
        <WhoFor />
        <WhyRead />
        <Testimonials testimonials={testimonials} config={config} />
        <TrustSection />
        <ComingSoon books={books} />
        <Social config={config} />
        <Contact config={config} />
      </main>
      <Footer config={config} />
    </div>
  );
}
